import * as Yup from "yup";

export const ADD_EDITOR_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required("Editor first name is required."),
  secondName: Yup.string().required(
    "Editor second name is required."
  ),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Editor Email is required.")
});

export const EDIT_EDITOR_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required("Editor first name is required."),
  secondName: Yup.string().required("Editor second name is required.")
});

export const getInitialValues = (editor) => {
  return {
    firstName: editor?.firstName || "",
    secondName: editor?.secondName || "",
    email: editor?.email || ""
  };
};
